import React from 'react';
import { Modal, ModalHeader, ModalFooter, Button, ModalBody } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import { EhpcMessageValues } from '../../Messages';


export interface EhpcModalProps {
  open: boolean;
  setOpen: Function;
  headerId: string;
  headerValues?: EhpcMessageValues;
  messageId: string;
  messageValues?: EhpcMessageValues;
  handleCancel?: Function;
  handleAccept: Function;
}

export const EhpcModal: React.FC<EhpcModalProps> = ({ 
  open, setOpen,
  headerId, headerValues = undefined, 
  messageId, messageValues = undefined, 
  handleCancel = () => {}, handleAccept }): JSX.Element | null => {
 
  const handleClickAccept = async (): Promise<void> => {
    setOpen(false);
    handleAccept();
  }

  const handleClickCancel = (): void => {
    setOpen(false);
    handleCancel();
  }

  return (
    <React.Fragment>
      <Modal isOpen={open} toggle={() => {setOpen(!open)}}>
        <ModalHeader>
          <FormattedMessage id={headerId} values={headerValues} />
        </ModalHeader>
        <ModalBody>
          <FormattedMessage id={messageId} values={messageValues} />
        </ModalBody>
        <ModalFooter>
          <Button
            color="secondary"
            onClick={handleClickCancel} >
            <FormattedMessage id="button_cancel"/>
          </Button>
          <Button 
            color="primary" 
            onClick={handleClickAccept} >
            <FormattedMessage id="button_ok"/>
          </Button>
        </ModalFooter>
      </Modal>
    </React.Fragment>
  );

}
